export type Nav_Link = {
  Href: string;
  Label: string;
};

export const Nav_Links: Nav_Link[] = [
  { Href: "/", Label: "Home" },
  { Href: "/contact", Label: "Contact Us" },
  { Href: "/values", Label: "Values" },
];

export const Brand_Tagline = "Advancement Built on Resonance and Discovery";

export const Home_Intro =
  "Parcel Q develops and licenses resilient technologies while guiding equity-driven housing and strategic partnerships.";

export const Product_Section_Label = "Parcel intelligence";

export const Product_Section_Title = "What ParcelQ does";

export const Product_Section_Intro =
  "Pre-development research in one place. Look up a parcel by APN or address, pull public records and GIS layers, then deliver diligence-ready reports—without hopping county portals by hand.";

export const Product_Capabilities = [
  {
    Title: "Parcel lookup",
    Body: "Resolve California parcels by APN or street address. Confirm geometry, zoning context, and ownership baselines before deeper research.",
  },
  {
    Title: "Public due diligence",
    Body: "Assemble assessor, tax, zoning, hazard, and recorded-document signals into structured reports with source attribution and automatic red flags.",
  },
  {
    Title: "Amenities & proximity",
    Body: "Map schools, transit, parks, grocery, and other nearby amenities within a chosen radius—plus livability and affordable-housing views.",
  },
] as const;

export const Values_Principle = "Lift as We Rise";

export const Values_Items = [
  {
    Title: "Resonance",
    Body: "Technologies harmonize with environments and existing systems—amplifying resilience, not fragility.",
  },
  {
    Title: "Never One Point of Failure",
    Body: "Redundancy and stability by design. No single disruption should collapse the whole system.",
  },
  {
    Title: "Equity",
    Body: "Innovation serves people. Housing equity models and community frameworks restore dignity and empower neighborhoods.",
  },
];

export const Contact_Body =
  "Seeking strategic partners, licensing opportunities, and collaborators who share our vision for resilient systems.";

export const Contact_Email = "info@sovereigncorellc.com";

export const News_Intro = "Updates on pipeline progress, partnerships, and deployment.";

export const News_Items = [
  {
    Date: "2025",
    Title: "Pipeline updates coming soon",
    Body: "ChickenBox and delivery architecture milestones will be posted as filings and partnerships finalize.",
  },
];
